<template>
  <div id="travel">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Travel'
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/travel/App.vue